import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ManagerRegister } from "../ManagerRegister";
import { IMAGES, TerminalImage } from "./TerminalImage";

export const Directory = () => (
  <section id="terminal-dir" className="py-20 border-b border-line bg-navy-alt" data-testid="directory-section">
    <div className="max-w-6xl mx-auto px-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 gap-4">
        <div>
          <span className="text-xs font-mono text-cy uppercase tracking-widest">[02] DIRECTORY INDEX</span>
          <h2 className="font-display text-4xl text-white uppercase mt-2">Verified Manager Register</h2>
        </div>
        <div className="text-xs font-mono text-mut">PUBLIC FACTS ONLY &bull; NO COMMERCIAL RATINGS</div>
      </div>

      <ManagerRegister preview={8} />

      <div className="mt-6 flex justify-end">
        <Link
          to="/directory"
          data-testid="directory-view-all-link"
          className="px-6 py-3 rounded border border-line bg-surface text-white font-mono text-xs hover:border-cy/50 transition-colors inline-flex items-center gap-2"
        >
          VIEW FULL REGISTER <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
        <div className="p-6 rounded-xl bg-surface border border-line font-mono text-xs">
          <div className="text-cy font-bold">DIRECTORY REGULATION NOTICE</div>
          <p className="text-mut mt-2 leading-relaxed font-body">
            Listings contain public licensing and strategy descriptors only, and are not endorsements.
            privatecredit.com.au does not accept placement fees, assign proprietary credit ratings, or endorse
            fund returns. Confirm licence details on ASIC Connect before relying on them.
          </p>
        </div>
        <div className="rounded-xl overflow-hidden border border-line">
          <TerminalImage
            src={IMAGES.directory}
            alt="Australian company register interface"
            testId="directory-visual"
            className="h-full min-h-[8rem] drift-cyan p-6"
          >
            <div className="text-xs font-mono text-mut mt-auto">
              <span className="block text-white font-bold">AU WHOLESALE REGISTRY</span>
              Public register data across Australian private credit providers.
            </div>
          </TerminalImage>
        </div>
      </div>
    </div>
  </section>
);
